/** Affiche code postal et ville sur une ligne. */
export function formatLocationLine(
  postalCode: string | null | undefined,
  city: string | null | undefined,
): string {
  const parts = [postalCode?.trim(), city?.trim()].filter(Boolean);
  return parts.join(" ");
}
